import { REMIX_SUPPORTED_FONTS } from 'shared/constants/fonts'

export const stripHtml = html => {
    const tmp = document.implementation.createHTMLDocument('New').body
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
}

function wrap(node, wrapper) {
    if (node && node.parentNode) {
        node.parentNode.insertBefore(wrapper, node)
        wrapper.appendChild(node)
    }
}
function wrapInner(node, wrapper) {
    const div = node.appendChild(wrapper)
    while (node.firstChild !== wrapper) div.appendChild(node.firstChild)
}

const getTextStyleProps = element => {
    const classList = element.classList

    const paragraphStyles = {}
    const spanStyles = {}

    for (const cn of classList) {
        const classAlign = cn.split('ql-align-')[1]
        if (classAlign) {
            paragraphStyles.textAlign = classAlign
        }
    }

    const _fontFamily = element.style.fontFamily
    if (_fontFamily) {
        spanStyles.fontFamily = _fontFamily
    } else {
        for (const cn of classList) {
            const classFontFamily = cn.split('ql-font-')[1]
            if (classFontFamily) {
                const potentialFontFamily = REMIX_SUPPORTED_FONTS.find(ff => ff.replaceAll(' ', '') === classFontFamily)
                if (potentialFontFamily) {
                    spanStyles.fontFamily = potentialFontFamily
                }
            }
        }
    }

    const _fontSize = element.style.fontSize
    if (_fontSize) spanStyles.fontSize = _fontSize

    const _color = element.style.color
    if (_color) spanStyles.color = _color

    const _lineHeight = element.style.lineHeight
    if (_lineHeight) {
        if (_lineHeight.endsWith('%')) {
            spanStyles.lineHeight = _lineHeight
        } else {
            spanStyles.lineHeight = Number(_lineHeight) * 100 + '%'
        }
    }

    const _letterSpacing = element.style.letterSpacing
    if (_letterSpacing) spanStyles.letterSpacing = _letterSpacing

    return [
        {
            tag: 'P',
            styles: paragraphStyles,
            isHasStyles: !!Object.keys(paragraphStyles).length,
        },
        {
            tag: 'SPAN',
            styles: spanStyles,
            isHasStyles: !!Object.keys(spanStyles).length,
        },
    ]
}

const getHtmlFromString = string => {
    try {
        const parser = new DOMParser()
        return parser.parseFromString(string, 'text/html')
    } catch (err) {
        return null
    }
}

function iterativelyWalk(nodes, cb) {
    const slice = Array.prototype.slice

    if (!('length' in nodes)) nodes = [nodes]

    nodes = slice.call(nodes)

    while (nodes.length) {
        const node = nodes.shift(),
            ret = cb(node)

        if (ret) return ret

        if (node.childNodes && node.childNodes.length) {
            nodes = slice.call(node.childNodes).concat(nodes)
        }
    }
}

export const formatContent = content => {
    const html = getHtmlFromString(content)

    iterativelyWalk(html.body, function (node) {
        if (node.style) {
            const textStyleProps = getTextStyleProps(node)
            textStyleProps.forEach(styleProps => {
                if (styleProps.isHasStyles) {
                    if (styleProps.tag !== node.tagName) {
                        const wrapper = document.createElement(styleProps.tag)
                        Object.entries(styleProps.styles).forEach(([key, value]) => {
                            wrapper.style[key] = value
                            node.style[key] = ''
                        })
                        wrapInner(node, wrapper)
                    } else {
                        Object.entries(styleProps.styles).forEach(([key, value]) => {
                            node.style[key] = value
                        })
                    }
                }
            })
        }
    })

    return html.body.innerHTML
}
